import React from 'react';

import { IconProps } from '../../DefaultIcon';
export function ContractTypesIcon({ className }: IconProps) {
  return (
    <svg
      width="86"
      height="70"
      viewBox="0 0 86 70"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1793)">
        <path
          d="M50.7499 57.0931V9.08108C48.0221 7.92492 43.0952 2.5015 41.6361 0H2.60093C1.16302 0 0 1.15616 0 2.58559V50.1351C0 53.961 3.12958 57.0721 6.97812 57.0721H50.7499V57.0931Z"
          fill="#D6DBE7"
        />
        <path
          d="M7.0625 57.0931C10.4458 57.0931 13.2159 54.5916 13.6811 51.3753C13.7446 50.8498 14.1886 50.4714 14.7173 50.4714H56.2899C56.9455 50.4714 57.4318 51.06 57.3261 51.6907C56.7551 54.7597 54.0273 57.0931 50.7709 57.0931H7.0625Z"
          fill="#00416B"
        />
        <path
          d="M25.3749 11.2041H5.28634C4.88457 11.2041 4.56738 10.8888 4.56738 10.4684C4.56738 10.048 4.88457 9.75366 5.28634 9.75366H25.3749C25.7766 9.75366 26.115 10.069 26.115 10.4684C26.115 10.8678 25.7978 11.2041 25.3749 11.2041Z"
          fill="#00416B"
        />
        <path
          d="M45.4635 17.0059H20.744C20.3422 17.0059 20.0039 16.6906 20.0039 16.2702C20.0039 15.8497 20.3211 15.5344 20.744 15.5344H45.4635C45.8652 15.5344 46.2036 15.8497 46.2036 16.2702C46.2036 16.6906 45.8652 17.0059 45.4635 17.0059Z"
          fill="#00416B"
        />
        <path
          d="M16.113 17.0059H5.28634C4.88457 17.0059 4.56738 16.6906 4.56738 16.2702C4.56738 15.8497 4.88457 15.5344 5.28634 15.5344H16.0918C16.4936 15.5344 16.832 15.8497 16.832 16.2702C16.832 16.6906 16.4936 17.0059 16.0918 17.0059"
          fill="#00416B"
        />
        <path
          d="M45.4633 22.8289H33.1141C32.7124 22.8289 32.374 22.5136 32.374 22.0932C32.374 21.6727 32.6912 21.3574 33.1141 21.3574H45.4633C45.865 21.3574 46.2034 21.6727 46.2034 22.0932C46.2034 22.5136 45.865 22.8289 45.4633 22.8289Z"
          fill="#00416B"
        />
        <path
          d="M28.4618 22.8289H5.286C4.88423 22.8289 4.5459 22.5136 4.5459 22.0932C4.5459 21.6727 4.86309 21.3574 5.286 21.3574H28.4618C28.8636 21.3574 29.2019 21.6727 29.2019 22.0932C29.2019 22.5136 28.8847 22.8289 28.4618 22.8289Z"
          fill="#00416B"
        />
        <path
          d="M45.4633 28.6306H20.4266C20.0249 28.6306 19.6865 28.3153 19.6865 27.8949C19.6865 27.4745 20.0037 27.1802 20.4266 27.1802H45.4633C45.865 27.1802 46.2034 27.4955 46.2034 27.8949C46.2034 28.2943 45.865 28.6306 45.4633 28.6306Z"
          fill="#00416B"
        />
        <path
          d="M15.7955 28.6306H5.286C4.88423 28.6306 4.5459 28.3153 4.5459 27.8949C4.5459 27.4745 4.86309 27.1802 5.286 27.1802H15.7955C16.1972 27.1802 16.5356 27.4955 16.5356 27.8949C16.5356 28.2943 16.2184 28.6306 15.7955 28.6306Z"
          fill="#00416B"
        />
        <path
          d="M45.4633 34.4324H33.1141C32.7124 34.4324 32.374 34.1171 32.374 33.6967C32.374 33.2763 32.6912 32.9609 33.1141 32.9609H45.4633C45.865 32.9609 46.2034 33.2763 46.2034 33.6967C46.2034 34.1171 45.865 34.4324 45.4633 34.4324Z"
          fill="#00416B"
        />
        <path
          d="M28.4618 34.4324H5.286C4.88423 34.4324 4.5459 34.1171 4.5459 33.6967C4.5459 33.2763 4.86309 32.9609 5.286 32.9609H28.4618C28.8636 32.9609 29.2019 33.2763 29.2019 33.6967C29.2019 34.1171 28.8847 34.4324 28.4618 34.4324Z"
          fill="#00416B"
        />
        <path
          d="M45.4633 40.2341H20.4266C20.0249 40.2341 19.6865 39.9188 19.6865 39.4984C19.6865 39.078 20.0037 38.7837 20.4266 38.7837H45.4633C45.865 38.7837 46.2034 39.099 46.2034 39.4984C46.2034 39.8978 45.865 40.2341 45.4633 40.2341Z"
          fill="#00416B"
        />
        <path
          d="M15.7955 40.2341H5.286C4.88423 40.2341 4.5459 39.9188 4.5459 39.4984C4.5459 39.078 4.86309 38.7837 5.286 38.7837H15.7955C16.1972 38.7837 16.5356 39.099 16.5356 39.4984C16.5356 39.8978 16.2184 40.2341 15.7955 40.2341Z"
          fill="#00416B"
        />
        <path
          d="M45.4633 46.0572H33.1141C32.7124 46.0572 32.374 45.7419 32.374 45.3214C32.374 44.901 32.6912 44.5857 33.1141 44.5857H45.4633C45.865 44.5857 46.2034 44.901 46.2034 45.3214C46.2034 45.7419 45.865 46.0572 45.4633 46.0572Z"
          fill="#00416B"
        />
        <path
          d="M41.6357 0L50.7496 9.08108H43.0314C42.249 9.08108 41.6357 8.45045 41.6357 7.69369V0Z"
          fill="#00C4B3"
        />
        <path
          d="M79.4238 70.0001V21.9671C76.696 20.8109 71.769 15.3875 70.3099 12.886H31.2748C29.8368 12.886 28.6738 14.0421 28.6738 15.4716V63.0211C28.6738 66.847 31.8034 69.9581 35.6519 69.9581H79.4238V70.0001Z"
          fill="#EAEDF8"
        />
        <path
          d="M35.7363 70C39.1197 70 41.8898 67.4985 42.355 64.2823C42.4184 63.7568 42.8625 63.3784 43.3911 63.3784H84.9638C85.6193 63.3784 86.1056 63.967 85.9999 64.5976C85.429 67.6667 82.7012 70 79.4447 70H35.7575H35.7363Z"
          fill="#00C4B3"
        />
        <path
          d="M54.0487 24.1111H33.9602C33.5584 24.1111 33.2412 23.7958 33.2412 23.3754C33.2412 22.9549 33.5584 22.6606 33.9602 22.6606H54.0487C54.4505 22.6606 54.7888 22.976 54.7888 23.3754C54.7888 23.7748 54.4716 24.1111 54.0487 24.1111Z"
          fill="#00416B"
        />
        <path
          d="M74.1373 29.9131H49.4178C49.0161 29.9131 48.6777 29.5978 48.6777 29.1774C48.6777 28.757 48.9949 28.4417 49.4178 28.4417H74.1373C74.5391 28.4417 74.8774 28.757 74.8774 29.1774C74.8774 29.5978 74.5391 29.9131 74.1373 29.9131Z"
          fill="#00416B"
        />
        <path
          d="M44.7657 29.9131H33.9602C33.5584 29.9131 33.2412 29.5978 33.2412 29.1774C33.2412 28.757 33.5584 28.4417 33.9602 28.4417H44.7657C45.1674 28.4417 45.5058 28.757 45.5058 29.1774C45.5058 29.5978 45.1674 29.9131 44.7657 29.9131Z"
          fill="#00416B"
        />
        <path
          d="M74.1371 35.7149H61.788C61.3862 35.7149 61.0479 35.3996 61.0479 34.9791C61.0479 34.5587 61.365 34.2434 61.788 34.2434H74.1371C74.5389 34.2434 74.8772 34.5587 74.8772 34.9791C74.8772 35.3996 74.5389 35.7149 74.1371 35.7149Z"
          fill="#00416B"
        />
        <path
          d="M57.1356 35.7149H33.9598C33.5581 35.7149 33.2197 35.3996 33.2197 34.9791C33.2197 34.5587 33.5369 34.2434 33.9598 34.2434H57.1356C57.5374 34.2434 57.8757 34.5587 57.8757 34.9791C57.8757 35.3996 57.5586 35.7149 57.1356 35.7149Z"
          fill="#00416B"
        />
        <path
          d="M74.1371 41.5376H49.1005C48.6987 41.5376 48.3604 41.2223 48.3604 40.8019C48.3604 40.3815 48.6775 40.0872 49.1005 40.0872H74.1371C74.5389 40.0872 74.8772 40.4025 74.8772 40.8019C74.8772 41.2013 74.5389 41.5376 74.1371 41.5376Z"
          fill="#00416B"
        />
        <path
          d="M44.4693 41.5376H33.9598C33.5581 41.5376 33.2197 41.2223 33.2197 40.8019C33.2197 40.3815 33.5369 40.0872 33.9598 40.0872H44.4693C44.8711 40.0872 45.2094 40.4025 45.2094 40.8019C45.2094 41.2013 44.8922 41.5376 44.4693 41.5376Z"
          fill="#00416B"
        />
        <path
          d="M74.1371 47.3394H61.788C61.3862 47.3394 61.0479 47.0241 61.0479 46.6037C61.0479 46.1832 61.365 45.8679 61.788 45.8679H74.1371C74.5389 45.8679 74.8772 46.1832 74.8772 46.6037C74.8772 47.0241 74.5389 47.3394 74.1371 47.3394Z"
          fill="#00416B"
        />
        <path
          d="M57.1356 47.3394H33.9598C33.5581 47.3394 33.2197 47.0241 33.2197 46.6037C33.2197 46.1832 33.5369 45.8679 33.9598 45.8679H57.1356C57.5374 45.8679 57.8757 46.1832 57.8757 46.6037C57.8757 47.0241 57.5586 47.3394 57.1356 47.3394Z"
          fill="#00416B"
        />
        <path
          d="M74.1371 53.1411H49.1005C48.6987 53.1411 48.3604 52.8258 48.3604 52.4054C48.3604 51.985 48.6775 51.6907 49.1005 51.6907H74.1371C74.5389 51.6907 74.8772 52.006 74.8772 52.4054C74.8772 52.8048 74.5389 53.1411 74.1371 53.1411Z"
          fill="#00416B"
        />
        <path
          d="M44.4693 53.1411H33.9598C33.5581 53.1411 33.2197 52.8258 33.2197 52.4054C33.2197 51.985 33.5369 51.6907 33.9598 51.6907H44.4693C44.8711 51.6907 45.2094 52.006 45.2094 52.4054C45.2094 52.8048 44.8922 53.1411 44.4693 53.1411Z"
          fill="#00416B"
        />
        <path
          d="M74.1371 58.9641H61.788C61.3862 58.9641 61.0479 58.6488 61.0479 58.2284C61.0479 57.808 61.365 57.4927 61.788 57.4927H74.1371C74.5389 57.4927 74.8772 57.808 74.8772 58.2284C74.8772 58.6488 74.5389 58.9641 74.1371 58.9641Z"
          fill="#00416B"
        />
        <path
          d="M70.2891 12.907L79.4029 21.9881H71.6847C70.9023 21.9881 70.2891 21.3574 70.2891 20.6007V12.928V12.907Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1793">
          <rect width="86" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
